import React from "react";

import './styles.css'

import {
    Box,
    IconButton,
    Typography,

} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import ViewAllExercises from "../planos/ViewAllExercises";
import { LoadingButton } from '@mui/lab';


function AddExsSessaoUtente(props){

  return (props.trigger) ? (
    <Box className="popup">
        <Box className="popup-inner">
            <Typography variant="h5">Adicionar Exercícios à Sessão "{props.sessao.title}"</Typography>

            <ViewAllExercises/>
                
            <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={() => props.setTrigger(false)}>
                Confirmar Seleção
            </LoadingButton>

            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
    </Box>
     
  ) : "";
}
export default AddExsSessaoUtente
